"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityKey = void 0;
/**
 * The entity dictionary keys. This enum is needed to have type safe redux reducers.
 */
var EntityKey;
(function (EntityKey) {
    /**
     * The key for the damage areas entities.
     */
    EntityKey["DAMAGE_AREAS"] = "damageAreas";
    /**
     * The key for the damages entities.
     */
    EntityKey["DAMAGES"] = "damages";
    /**
     * The key for the images entities.
     */
    EntityKey["IMAGES"] = "images";
    /**
     * The key for the inspections entities.
     */
    EntityKey["INSPECTIONS"] = "inspections";
    /**
     * The key for the parts entities.
     */
    EntityKey["PARTS"] = "parts";
    /**
     * The key for the tasks entities.
     */
    EntityKey["TASKS"] = "tasks";
    /**
     * The key for the vehicles entities.
     */
    EntityKey["VEHICLES"] = "vehicles";
    /**
     * The key for the views entities.
     */
    EntityKey["VIEWS"] = "views";
    /**
     * The key for the wheel analysis entities.
     */
    EntityKey["WHEEL_ANALYSIS"] = "wheelAnalysis";
})(EntityKey = exports.EntityKey || (exports.EntityKey = {}));
//# sourceMappingURL=entities.js.map